import React from 'react';
import PropTypes from 'prop-types';

class DropdownItemComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { handleChange, association } = this.props;
    e.preventDefault();
    handleChange(association.key);
  }

  render() {
    const { association } = this.props;
    return (
      <li className={association.selected ? 'selected' : ''}>
        <button type="button" onClick={this.handleClick}>
          {association.value}
        </button>
      </li>
    );
  }
}

DropdownItemComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  association: PropTypes.shape({
    key: PropTypes.number.isRequired,
    selected: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};

DropdownItemComponent.displayName = 'DropdownItemComponent';

// Uncomment properties you need
// DropdownItemComponent.propTypes = {};
// DropdownItemComponent.defaultProps = {};

export default DropdownItemComponent;
